/**
 * <s-brand-pick> wraps the Brand-tier brand radios (properties[Brand]).
 * The product form re-renders on every hand/size/plan change, which would clear the pick,
 * so the last choice is kept in memory for this page view and restored on reconnect.
 */
let lastBrand = '';

class SBrandPick extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    if (lastBrand) {
      for (const input of this.querySelectorAll('input[name="properties[Brand]"]')) {
        if (input instanceof HTMLInputElement && input.value === lastBrand) input.checked = true;
      }
    }
    this.addEventListener('change', (event) => {
      const input = event.target;
      if (input instanceof HTMLInputElement && input.name === 'properties[Brand]' && input.checked) lastBrand = input.value;
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-brand-pick')) customElements.define('s-brand-pick', SBrandPick);
